export default __webpack_public_path__ + "static/media/sign_in_logo.189d7a9a.png";